import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { useAppDispatch, useAppSelector } from "../../../../app/hook";
import {
  botsUiState,
  handleSetLivePreviewTargetBot
} from "../../../../features/bot/botSlice";

const LivePreview = () => {
  const dispatch = useAppDispatch();

  const { livePreviewTargetBot } = useAppSelector(botsUiState);

  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (livePreviewTargetBot)
      localStorage.setItem("live_bot_id", livePreviewTargetBot);
  }, [livePreviewTargetBot]);

  useEffect(() => {
    let timeOut = null;

    if (livePreviewTargetBot) setIsScriptLoaded(true);
    else {
      // This id is coming from iframe generated in live widget script
      const iframeEl = document.getElementById(
        "ps_w_live"
      ) as HTMLIFrameElement | null;

      if (iframeEl) {
        // TODO => Investigate why direct domain from location does not work
        iframeEl.contentWindow?.postMessage({ action: "clearSession" }, "*");

        setIsScriptLoaded(false);

        dispatch(handleSetLivePreviewTargetBot(""));

        timeOut = setTimeout(() => {
          iframeEl.remove();
        }, 1000);
      }
    }

    return () => {
      if (timeOut) clearTimeout(timeOut);
    };
  }, [livePreviewTargetBot]);

  return (
    <React.Fragment>
      <Helmet>
        {/* Live preview script */}
        {isScriptLoaded && (
          <script
            key="livePreviewScript"
            src={import.meta.env.VITE_LIVE_PREVIEW_SCRIPT_URL}
            id="livePreviewScript"
            onError={() => {
              const scriptEl = document.getElementById(
                "ps_w_live"
              ) as HTMLIFrameElement | null;

              if (scriptEl) {
                // TODO => Investigate why direct domain from location does not work
                scriptEl.contentWindow?.postMessage(
                  { action: "clearSession" },
                  "*"
                );

                setIsScriptLoaded(false);

                dispatch(handleSetLivePreviewTargetBot(""));

                setTimeout(() => {
                  scriptEl.remove();
                }, 1000);
              }
            }}
          ></script>
        )}
      </Helmet>
    </React.Fragment>
  );
};

export default LivePreview;
